<template>
	<div class="export-step-second">
		<p>请匹配系统目标字段和导入字段的关系</p>
		<el-table :data="stepSecond.columnList" style="width: 100%" @selection-change="handleSelectionChange" ref="table">
			<el-table-column type="index" label="序号">
			</el-table-column>
			<el-table-column prop="date" label="原始字段">
				<template slot-scope="scope"><span>{{scope.row[4]}}</span></template>
			</el-table-column>
			<el-table-column prop="name" label="目标字段">
				<template slot-scope="scope">
					<el-select v-model="stepSecond.excelColumnList[scope.$index][0]" placeholder="请选择" size="mini" clearable>
					    <el-option
					      v-for="(item,index) in stepSecond.excelColumnList"
					      :key="index"
					      :label="item[4]"
					      :value="item[0]">
					    </el-option>
					  </el-select>
				</template>
			</el-table-column>
			<el-table-column type="selection" width="100px"  label-class-name="DisabledSelection"></el-table-column>
			
		</el-table>
		<div class="footer">
			<el-button @click="onCancel">返回</el-button>
			<el-button type="primary" @click="onSubmit" :loading="loading">{{loading ? '提交中' : '立即提交'}}</el-button>
			
		</div>
	</div>
</template>

<script>
	export default {
		props:['stepSecond'],
		data(){
			return {
				// stepSecond:{
				// 	columnList:[
				// 		['original_id','char(32)','PK','yuanshishujuid','原始数据ID','-99'],
				// 		['channel_identify','char(32)','','qudao','渠道','-96'],
				// 		['child_brand_identify','char(32)','','zipinpai','子品牌','-99'],
				// 		['create_time','datetime','','chuangjianshijian','创建时间','-99'],
				// 	],
				// 	excelColumnList:[
				// 		['original_id','char(32)','PK','yuanshishujuid','原始数据ID','-99'],
				// 		['channel_identify','char(32)','','qudao','渠道','-96'],
				// 		['child_brand_identify','char(32)','','zipinpai','子品牌','-99'],
				// 		['create_time','datetime','','chuangjianshijian','创建时间','-99'],
				// 	],
				// 	batchNum:'yyyy'
				// },
				multipleSelection:[],
				loading:false,
			}
		},
		methods: {
			onCancel() {
				this.$emit('goBack')
			},
			onSubmit(){
				if(this.multipleSelection.length == 0) {
					this.$notify.error('请先设置联系电话');
					return;
				}
				if(this.multipleSelection.length > 1) {
					this.$notify.error('联系电话只能设置一个');
					return;
				}
				this.loading = true;
				let params = {
					batchNum:this.stepSecond.batchNum,
					contactNumberColumn:this.multipleSelection[0][4],
					mappingRelas:this.getIds(),
					deleteColumnCodes:'',
					brandIdentify:this.$store.getters.userInfo.brandIdentify
				}
				this.$api.stepSecondBreathdataBaseList(params).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.$notify.success('操作成功');
					this.$emit('updateStepSecond',res.data);
				}).catch(err => {
					this.loading = false;
				})
			},
			handleSelectionChange(row){
				if(row.length > 1){
					this.$refs.table.clearSelection()
					this.$refs.table.toggleRowSelection(row.pop())
				  }else{
					this.multipleSelection = row;
				  }  
				
			},
			getIds(){
				let results = [];
				this.stepSecond.excelColumnList.map((item,index) => {
					if(this.stepSecond.columnList[index][0]){
						results.push(`${this.stepSecond.columnList[index][0]},${item[0]}`)
					}else {
						results.push(`'',${item[0]}`)
					}
					
				})
				
				results = results.length > 0 ? results.join(';') : ''
				return results;
			}
		},
	}
</script>

<style lang="scss" scoped>
	.export-step-second {
		margin-top: 20px;
		width: 100%;
		font-size: 14px;
		color: #838A9D;
		::v-deep {
			.el-table .cell {
				padding: 10px 0 !important;
			}
			.DisabledSelection .cell .el-checkbox__inner {
				display:none;
				position:relative;
			}
			.DisabledSelection .cell:before {
				content: '联系电话设置';
				position: absolute;
				right: 11px;
			}
		}
		.footer {
			margin-top: 20px;
			float: right;
		}
	}
</style>